import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  checkString,
  checkStringNew,
  mobileNumber,
  noDataFound,
  splitDate,
  splitDateSlash,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../../Configuration/API_URL";
import Loader from "../../Common/Loader";
import SmallLoader from "../../Common/smallLoader";
import DPDropdown from "../../../CommonMethhods/DPDropdown";

function ClientSummary(props) {
  // const riskProfile = props.riskProfileData;
  const storeToken = localStorage.getItem("ssoToken");
  const [clientSum, setClientSum] = useState();
  const [loader, setLoader] = useState(true);
  const [serverError, setServerError] = useState("");
  let clientCode = "";
  let clientPan =
    localStorage.getItem("panId") || localStorage.getItem("clientPan");

  const getClientSummary = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const clientSummaryData = await axios.post(
        DASHBOARD_CLIENT_OVERVIEW.ClientSummary_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const clientSummaryResp = ApiResDecrypt(clientSummaryData?.data);
      setClientSum(clientSummaryResp?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setServerError("Something went wrong, Please try again later.");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getClientSummary(clientCode);
    }
  }, []);
  console.log(clientSum, "clientSum");

  return (
    <>
      <div className="col-12 col-lg-6 bottom-ipad-20 mobile-bottom-20">
        <div className="card-box">
          <div className="card-title">
            <h2>{Constants.Client_Summary}</h2>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <div className="client-summary">
              {clientSum && clientSum ? (
                <>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Client_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.PARTY_CODE)}
                          </>
                        )}
                      </h5>
                    </li>
                    {/* <li className="client-li">
                      <p className="client-p">{Constants.DP_no}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.CLTDPID)}
                          </>
                        )}
                      </h5>
                    </li> */}
                    <li className="client-li">
                      <p className="client-p">{Constants.DP_no}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum) ? (
                              "NA"
                            ) : (
                              // <DPDropdown dpIdList={clientSum.dpIdList} />
                              <DPDropdown
                                dpIdList={clientSum.dpIdList}
                                CLTDPID={clientSum.CLTDPID}
                              />
                            )}
                          </>
                        )}
                      </h5>
                    </li>

                    <li className="client-li">
                      <p className="client-p">{Constants.Last_Traded_Date}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "-"
                              : splitDateSlash && checkStringNew(clientSum?.LAST_TRADE_DATE)}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Primary_Bank}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.BANK_NAME)}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Account_no}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(mobileNumber(clientSum.AC_NUM))}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.IFSC_CODE}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.IFSC)}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Dealer_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.DEALER_CODE)}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.RM_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.RM_CODE)}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Branch_Name_Code}</p>
                      <h5 className="client-h5">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.BRANCH_CD)}
                          </>
                        )}
                      </h5>
                    </li>
                  </ul>
                  <ul className="client-ul">
                    <li className="client-li">
                      <p className="client-p">{Constants.Mobile}</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.mobile)}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">{Constants.Segments}</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>
                            {checkEmpty(clientSum)
                              ? "NA"
                              : checkString(clientSum.segment)}
                          </>
                        )}
                      </h5>
                    </li>
                    <li className="client-li">
                      <p className="client-p">PAN No</p>
                      <h5 className="client-h5 segment-client">
                        {loader ? (
                          <SmallLoader />
                        ) : (
                          <>{mobileNumber(clientPan) || "N.A"}</>
                        )}
                      </h5>
                    </li>
                  </ul>
                </>
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ClientSummary;
